import React from 'react';
import ReactDOM from 'react-dom/client';
import AppShell from './AppShell';
import reportWebVitals from './reportWebVitals';
import Cookies from 'js-cookie';

import 'nprogress/nprogress.css';
import './styles/index.less';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
if (Cookies.get('aurum-slides')) {
  window.location.href = '/docs/react/introduce';
} else {
  Cookies.set('aurum-slides', '1', { expires: 365 });
  root.render(
    <React.StrictMode>
      <AppShell />
    </React.StrictMode>,
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
